import i18next from '@/i18n/config';
import { store } from '@/store';
import GlobalStyle from '@/theme/global-style';
import { theme } from '@/theme/theme';
import { useLocation } from '@reach/router';
import 'bootstrap-icons/font/bootstrap-icons.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import styled, { ThemeProvider } from 'styled-components';

import LiveChatBox from '@/components/common/LiveChatBox';
import Header from '@/components/layout/Header';
import { Script } from 'gatsby';
import { PROD_GTM, PROD_HOST, UAT_GTM } from '@/constants';
import { getOrigin } from '@/hooks/useRouteSection';
import { GlobalIOSButtonFix } from '../common/GlobalIOSButtonFix';

const Layout = (props: any) => {
  const origin = getOrigin() || '';
  const GTMCode = origin.includes(PROD_HOST) ? PROD_GTM : UAT_GTM;
  const location = useLocation();
  return (
    <Provider store={store}>
      <Script id="first-unique-id">
          {`
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-${GTMCode}');
            `}
      </Script>
      <GlobalStyle />
      <GlobalIOSButtonFix />
      <ThemeProvider theme={theme}>
        {<Header />}
        <Styles>
          <I18nextProvider i18n={i18next}>{props.children}</I18nextProvider>
        </Styles>
        {/* {<Footer />} */}
        <LiveChatBox />
      </ThemeProvider>
    </Provider>
  );
};

export default Layout;

const Styles = styled.div`
  margin: 0px auto;
  padding-top: 0px;
  min-height: calc(100vh - 10rem);
  background: #fff bottom no-repeat;
`;
